"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTextField = _interopRequireDefault(require("../cwtextfield/CwTextField"));

var _CwButton = _interopRequireDefault(require("../cwbutton/CwButton"));

var _CwFileUpload = _interopRequireDefault(require("./CwFileUpload.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwFileUpload =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CwFileUpload, _Component);

  function CwFileUpload() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwFileUpload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwFileUpload)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      if (_this.props.onBeforeClick) {
        var result = _this.props.onBeforeClick();

        if (result) {
          _this.inputField.click();
        }
      } else {
        _this.inputField.click(); // emulate clicking the hidden file input

      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFileChange", function (event) {
      // Update
      if (!event.target.files || event.target.files.length < 1) {
        return;
      }

      var files = event.target.files;

      if (_this.props.hasTextField && _this.props.onChange) {
        if (event.target.files.length > 1) {
          _this.props.onChange(files.length + " files");
        } else {
          _this.props.onChange(files[0].name);
        }
      }

      if (_this.props.onFileChanged) {
        _this.props.onFileChanged(files);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CwFileUpload, [{
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var fileUploadClass = (0, _classnames.default)(_CwFileUpload.default.wrap, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwFileUpload.default.wrapWithTextField, this.props.hasTextField && !this.props.disabled), (0, _defineProperty2.default)(_cx, _CwFileUpload.default.wrapWithTextFieldInvalid, this.props.hasTextField && this.props.invalid), (0, _defineProperty2.default)(_cx, _CwFileUpload.default.wrapDisabled, this.props.disabled && this.props.hasTextField), _cx));
      return _react.default.createElement("div", {
        className: fileUploadClass,
        tabIndex: 0
      }, _react.default.createElement("input", {
        className: _CwFileUpload.default.file,
        accept: this.props.accept,
        type: "file",
        tabIndex: "-1",
        ref: function ref(input) {
          return _this2.inputField = input;
        },
        onChange: this.handleFileChange,
        multiple: this.props.multiple
      }), this.props.hasTextField ? _react.default.createElement(_CwTextField.default, {
        value: this.props.value,
        tabIndex: -1,
        onChange: this.props.onChange,
        readOnly: this.props.readOnly,
        className: _CwFileUpload.default.inputFileText
      }) : null, _react.default.createElement(_CwButton.default, {
        cwId: this.props.cwId,
        className: this.props.buttonClassName,
        disabled: this.props.disabled,
        value: this.props.text,
        onClick: this.handleClick,
        icon: this.props.icon,
        topIcon: this.props.topIcon,
        isStandard: this.props.isStandard,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        tabIndex: -1
      }));
    }
  }]);
  return CwFileUpload;
}(_react.Component);

CwFileUpload.propTypes = {
  /**
   *  Function that is called before the input field opens.
   *  Should return a boolean that determines whether the
   *  input field opens or not.
   */
  onBeforeClick: _propTypes.default.func,

  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Callback fired when files are chosen for upload
   */
  onChange: _propTypes.default.func,

  /**
   * Determines which file types can be uploaded
   * accepts file extensions, media types, and 
   * audio/*|video/*|image/*
   */
  accept: _propTypes.default.string,

  /**
   * Renders a textfield to the left of the button if true
   */
  hasTextField: _propTypes.default.bool,

  /**
   * Used to control button styling
   */
  isStandard: _propTypes.default.bool,

  /**
   * Optional icon placed on left side of button
   */
  icon: _propTypes.default.string,

  /**
   * Optional icon placed on top of button
   */
  topIcon: _propTypes.default.string,

  /**
   * CSS class name to be used for styling the button
   */
  buttonClassName: _propTypes.default.string,

  /**
   * Allows multiple file upload if true
   */
  multiple: _propTypes.default.bool,

  /**
   * Call fired when the button is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the button is blured
   */
  onBlur: _propTypes.default.func,

  /**
   * Text for button
   */
  text: _propTypes.default.string,

  /**
   * Controls whether the file upload is disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Text displayed in text field
   */
  value: _propTypes.default.string,

  /**
   * Callback fired when a new file is selected
   */
  onFileChanged: _propTypes.default.func,

  /**
   * Controls if the text field is read only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Used to control if text field is valid
   */
  invalid: _propTypes.default.bool
};
CwFileUpload.defaultProps = {
  accept: '',
  hasTextField: true,
  buttonClassName: _CwFileUpload.default.browseButton
};
var _default = CwFileUpload;
exports.default = _default;